import { html, type TemplateResult } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import { renderExternalEmbedGate } from '../common/external-embed-gate.js';

export interface LoomVideoOptions {
  videoId: string;
  /** Proxied preview image (proxiedPreviewUrl), or null. */
  previewImageUrl: string | null;
  /** The reader released the video for this view. */
  loaded: boolean;
  onLoad: () => void;
  overlayHidden: boolean;
}

export function loomEmbedUrl(videoId: string): string {
  return `https://www.loom.com/embed/${videoId}?hide_title=true`;
}

/**
 * Video area of the Loom block: the external-content placeholder until the
 * reader loads the video, then the player.
 */
export function renderLoomVideo({
  videoId,
  previewImageUrl,
  loaded,
  onLoad,
  overlayHidden,
}: LoomVideoOptions): TemplateResult {
  if (!loaded) {
    return html`<div class="affine-embed-loom-video-iframe-container">
      ${renderExternalEmbedGate({ provider: 'loom', previewImageUrl, onLoad })}
    </div>`;
  }

  return html`<div class="affine-embed-loom-video-iframe-container">
    <iframe
      src=${loomEmbedUrl(videoId)}
      frameborder="0"
      allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      loading="lazy"
      credentialless
    ></iframe>

    <!-- overlay to prevent the iframe from capturing pointer events -->
    <div
      class=${classMap({
        'affine-embed-loom-video-iframe-overlay': true,
        hide: overlayHidden,
      })}
    ></div>
  </div>`;
}
